import gt from "common/analytics/google-tagmanager";

export function generateEmployeeTrackingFunctions (category) {
  const property = "employee_selection";

  function employeeSelectionInitialised (employeeCount) {
    return gt.trackEventAsync({
      category,
      property,
      action: "loaded",
      value: employeeCount
    });
  }

  function employeeSelectionOpen (employeeCount) {
    return gt.trackEventAsync({
      category,
      property,
      action: "open",
      value: employeeCount
    });
  }

  function employeeSelectionClose (employeeCount) {
    return gt.trackEventAsync({
      category,
      property,
      action: "close",
      value: employeeCount
    });
  }

  function employeeSelectionSelect (employeeId, employeeIndex, employeeCount) {
    return gt.trackEventAsync({
      category,
      property,
      action: "select_" + employeeIndex,
      label: employeeId === "any" ? "any_employee" : employeeId,
      value: employeeCount
    });
  }

  return {
    init: employeeSelectionInitialised,
    open: employeeSelectionOpen,
    close: employeeSelectionClose,
    select: employeeSelectionSelect
  };
}

export function generateDateTrackingFunctions (category) {
  const property = "date";
  const propertyPriceRange = "date_price_range";

  function trackInitial (label, selectedIndex) {
    return gt.trackEventAsync({
      category,
      property,
      action: "initial_state_loaded",
      label: label,
      value: selectedIndex
    });
  }

  function trackSelect (selectedIndex) {
    return gt.trackEventAsync({
      category,
      property,
      action: "select",
      value: selectedIndex
    });
  }

  // A date selection that was a result of another user action,
  // such as week navigation.
  function trackAutoSelect (selectedIndex) {
    return gt.trackEventAsync({
      category,
      property,
      action: "autoselect",
      value: selectedIndex
    });
  }

  function trackForwards () {
    return gt.trackEventAsync({
      category,
      property,
      action: "scroll_click",
      label: "forwards"
    });
  }

  function trackBackwards () {
    return gt.trackEventAsync({
      category,
      property,
      action: "scroll_click",
      label: "backwards"
    });
  }

  function trackPriceRange (
    action,
    minPrice,
    maxPrice,
    minPriceSlots,
    slotsNumber,
    discountAvailable,
    selectedIndex
  ) {
    return gt.trackEventAsync({
      category,
      property: propertyPriceRange,
      action: action,
      label: `${minPrice},${maxPrice},${minPriceSlots},${slotsNumber},${discountAvailable}`,
      value: selectedIndex
    });
  }

  return {
    initial: trackInitial,
    autoselect: trackAutoSelect,
    select: trackSelect,
    forwards: trackForwards,
    backwards: trackBackwards,
    priceRange: trackPriceRange
  };
}

export function generateTimeTrackingFunctions (category) {
  const property = "time";

  function trackSelect (selectedIndex) {
    return gt.trackEventAsync({
      category,
      property,
      action: "select",
      value: selectedIndex
    });
  }

  return {
    select: trackSelect
  };
}
